import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-printtest',
  templateUrl: './printtest.component.html',
  styleUrls: ['./printtest.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrinttestComponent implements OnInit {

  ngOnInit(): void {
    this.printPDF();
  }

  printPDF() {
  const doc = new jsPDF();
  doc.text('Hello, this is your content!', 10, 10);
  const blob = doc.output('blob');

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  const url = URL.createObjectURL(blob);
  iframe.src = url;

  iframe.onload = () => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
  };
}


}

